import { ChatType } from '../generated/graphql';

/** The handful of chat fields that decide where a thread opens. */
export interface ChatDestination {
  id?: string | null | undefined;
  chatType?: ChatType | string | null | undefined;
  job_id?: string | null | undefined;
  estimate_id?: string | null | undefined;
  invoice_id?: string | null | undefined;
  appointment_id?: string | null | undefined;
}

/** The inbox, with the thread open. `/inbox?chat=` is read by nothing. */
export const inboxThreadRoute = (chatId: string): string => `/inbox/${chatId}`;

/**
 * The page of the record a thread hangs off, or null when there is none.
 *
 * Every chat but a direct one belongs to a job, an estimate, an invoice or an
 * appointment, and that record's page shows the conversation along with
 * everything else the reader came for. A direct chat has no record, so it has
 * nowhere to go but the inbox.
 */
export const chatRecordRoute = (chat: ChatDestination | null | undefined): string | null => {
  if (!chat) return null;

  switch (chat.chatType) {
    case ChatType.Job:
      return chat.job_id ? `/jobs/${chat.job_id}` : null;
    case ChatType.Estimate:
      return chat.estimate_id ? `/estimates/${chat.estimate_id}` : null;
    case ChatType.Invoice:
      return chat.invoice_id ? `/invoices/${chat.invoice_id}` : null;
    case ChatType.Appointment:
      return chat.appointment_id ? `/appointments/${chat.appointment_id}` : null;
    default:
      return null;
  }
};
